import { createEnv } from '@t3-oss/env-core';
import { z } from 'zod';

export const configs = createEnv({
  // Add server variables here
  server: {
    GIT_HASH: z.string().optional(),
  },
  clientPrefix: 'NEXT_PUBLIC_',
  // Add client variables here (must be prefixed with NEXT_PUBLIC_)
  client: {
    NEXT_PUBLIC_BACKEND_URL: z.string().url(),
    NEXT_PUBLIC_ENVIRONMENT: z
      .enum(['development', 'staging', 'production', 'testing', 'build'])
      .default('development'),
    NEXT_PUBLIC_SSD_GTM_ID: z.string(),
    NEXT_PUBLIC_APP_DOMAIN: z.string().default('localhost'),
  },
  runtimeEnvStrict: {
    // Server variables
    GIT_HASH: process.env.GIT_HASH,

    // Client variables (prefixed with NEXT_PUBLIC_)
    NEXT_PUBLIC_BACKEND_URL: process.env.NEXT_PUBLIC_BACKEND_URL,
    NEXT_PUBLIC_ENVIRONMENT: process.env.NEXT_PUBLIC_ENVIRONMENT,
    NEXT_PUBLIC_SSD_GTM_ID: process.env.NEXT_PUBLIC_SSD_GTM_ID,
    NEXT_PUBLIC_APP_DOMAIN: process.env.NEXT_PUBLIC_APP_DOMAIN,
  },
});
